import { render, staticRenderFns } from "./SendMessageToParent.vue?vue&type=template&id=3f82e299"
import script from "./SendMessageToParent.vue?vue&type=script&lang=ts"
export * from "./SendMessageToParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports